import moment from 'moment';
import { localization } from './l10n';

const $tr = localization.tr.bind(localization);

const Utils = {
    sizeToString(value) {
        if (value == null) {
            return '-';
        }
        const units = [$tr('Б'), $tr('КБ'), $tr('МБ'), $tr('ГБ'), $tr('ТБ'), $tr('ПБ'), $tr('ЭБ')];
        let i = 0;
        let size = value;
        while (size > 1024.0) {
            size /= 1024.0;
            i += 1;
        }
        return `${Math.round(size * 100.0) / 100.0} ${units[i]}`;
    },

    secondsToString(pvalue) {
        let value = pvalue;
        let suffix = $tr('с');
        if (value > 120) {
            value /= 60;
            suffix = $tr('м');
            if (value > 120) {
                value /= 60;
                suffix = $tr('ч');
                if (value > 48) {
                    value /= 24;
                    suffix = $tr('дн');
                }
            }
        }
        return `${value} ${suffix}`;
    },

    userToString(user) {
        if (user == null) {
            return '';
        }
        const result = (`${user.name || ''} ${user.surname || ''}`).trim();
        if (result === '') {
            return user.email || user.uid;
        }
        return result;
    },

    companyToString(company) {
        return company != null ? company.name : '';
    },

    groupToString(group) {
        if (group != null) {
            return `${group.name} ${$tr('(Группа)')}`;
        }
        return '';
    },

    parseDate(date) {
        if (date.endsWith('GMT')) {
            return moment(date);
        } if (date.indexOf('T') > 0) {
            return moment(`${date}+00:00`);
        }
        return moment(`${date}+00:00`);
    },

    dateTimeToString(date) {
        return date != null ? this.parseDate(date)?.format('DD.MM.YY, HH:mm:ss') : '';
    },

    dateTimeFromNow(date) {
        return date != null ? this.parseDate(date)?.fromNow() : '';
    },
};

export default Utils;
